module.exports = __webpack_public_path__ + "img/ocean-waves.c1938ab7.jpg";